export const patchSuccessToast = {
  title:
    '$t(tracker:displayKind, {"context": "{{context}}" }) has been successfully modified.',
};
